import { GAME_ITEM_COUNT, GameType } from "../Data/GameData";
import { GameProgress } from "../Data/GameProgress";

export class AppProgress {
    private static _games: GameProgress[];
    private static _recentGame: GameType | undefined;

    public static get games(): GameProgress[] {
        if (this._games === undefined) {
            this._games = new Array<GameProgress>(GameType.NUM_ELEMENTS);
            for (let i = 0; i < this._games.length; ++i) {
                this._games[i] = new GameProgress(GAME_ITEM_COUNT[i]);
            }
            // Set onboarding to complete to prevent multiple painting onboarding (only run it for Mask)
            this._games[GameType.DOLL].isOnboardingComplete = true;
            this._games[GameType.DRESS].isOnboardingComplete = true;
        }
        return this._games;
    }

    public static get recentGame(): GameType | undefined {
        return this._recentGame;
    }

    public static set recentGame(pValue: GameType | undefined) {
        this._recentGame = pValue;
    }
}
